
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class SplittingBOMDialog extends Serenity.EntityDialog<SplittingBOMRow, any> {
        protected getFormKey() { return SplittingBOMForm.formKey; }
        protected getIdProperty() { return SplittingBOMRow.idProperty; }
        protected getLocalTextPrefix() { return SplittingBOMRow.localTextPrefix; }
        protected getNameProperty() { return SplittingBOMRow.nameProperty; }
        protected getService() { return SplittingBOMService.baseUrl; }
        protected getDeletePermission() { return SplittingBOMRow.deletePermission; }
        protected getInsertPermission() { return SplittingBOMRow.insertPermission; }
        protected getUpdatePermission() { return SplittingBOMRow.updatePermission; }

        protected form = new SplittingBOMForm(this.idPrefix);

    }
}